import service from "@/helpers/py-service";

const state = {
  loading: false,
  meta: {},
  list: [],
};

const mutations = {
  SET_META(state, data) {
    if (data.meta) {
      state.meta.page = data.meta.current_page;
      state.meta.itemsPerPage = data.meta.per_page;
      state.meta.lastPage = data.meta.last_page;
      state.meta.totalItems = data.meta.total;
    }
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  ADD_LIST(state, payload) {
    state.list.push(payload);
  },
  UPDATE_LIST(state, row) {
    const item = state.list.find((item) => item.id === row.id);
    Object.assign(item, row);
  },

  DELETE_LIST(state, payload) {
    state.list.splice(state.list.map((o) => o.id).indexOf(payload.id), 1);
  },
};

const actions = {
  list: (store, params) => {
    store.state.loading = true;
    service
      .get(`charging-station/tenant-charger-assignments`, params)
      .then((data) => {
        store.commit("SET_META", data.body);
        store.commit("SET_LIST", data.body.data);
        // if (params.page) {
        // } else {
        //   store.commit("SET_LIST", data.body);
        // }
      })
      .finally(() => (store.state.loading = false));
  },

  add: (store, { payload, filter }) => {
    store.state.loading = true;
    return service
      .post(`charging-station/tenant-charger-assignments/bulk`, payload)
      .then(() => {
        // store.commit("ADD_LIST", data.body);
        store.dispatch("list", filter);
      })
      .finally(() => (store.state.loading = false));
  },

  update: (store, payload) => {
    store.state.loading = true;
    return service
      .put(`charging-station/tenant-charger-assignments/${payload.id}`, payload)
      .then((data) => {
        store.commit("UPDATE_LIST", data.body);
      })
      .finally(() => (store.state.loading = false));
  },

  destroy: (store, payload) => {
    store.state.loading = true;

    return service
      .destroy(
        `charging-station/tenant-charger-assignments/${payload.id}`,
        payload
      )
      .then(() => {
        store.commit("DELETE_LIST", payload);
      })
      .finally(() => (store.state.loading = false));
  },
};

const getters = {
  getLoading(state) {
    return state.loading;
  },
  getMeta(state) {
    return state.meta;
  },
  getList(state) {
    return state.list;
  },
};

const csoClients = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default csoClients;
